import { ContactSubjectType, OrganizationType } from "../../../../autogen/bff-api";

export interface ContactSubject {
  subjectType: ContactSubjectType;
  subjectId: string;
  name: string;
}

export const registeredOrganizationSubject = (organization: { id: string; name: string }): ContactSubject => ({
  subjectType: ContactSubjectType.RegisteredOrganization,
  subjectId: organization.id,
  name: organization.name,
});

export const organizationEntrySubject = (entry: { id: string; name: string }): ContactSubject => ({
  subjectType: ContactSubjectType.OrganizationEntry,
  subjectId: entry.id,
  name: entry.name,
});

export const subjectOrganizationType = (subjectType: ContactSubjectType): OrganizationType =>
  subjectType === ContactSubjectType.OrganizationEntry ? OrganizationType.OrganizationEntry : OrganizationType.Organization;
